import { DefaultParams } from '@/api/bbsworld/default';
import { ClientAuth } from '@/classes/ClientAuth';
import { Device } from '@/classes/Device';
import { API_URL, API_VERSION } from '@/constants';
import { Content, CONTENT_TYPE, VIDEO_CATEGORY } from '@/types';
import { stringify } from 'qs';

export type GetContentsParams = {
  type?: CONTENT_TYPE;
  category?: VIDEO_CATEGORY;
  contentGroupId?: number;
  search?: string;

  thumbnailType?: 'HORIZONTAL' | 'VERTICAL';

  limit?: number;
  offset?: number;
} & DefaultParams;

export async function getContents(params: GetContentsParams): Promise<{
  contentTypes: Array<'ALL' | 'GAME' | 'VIDEO'>;
  contents: Array<Content>;
}> {
  const response = await fetch(
    `${API_URL}/api/${API_VERSION}/contents?${stringify({
      deviceId: Device.uuid,
      ...params,
    })}`,
    {
      method: 'GET',
      headers: ClientAuth.headers,
      credentials: 'include',
    },
  );
  const data = await response.json();

  return data;
}
